/**
 * Modal Loader
 * Thin delegated listener that detects modal triggers and lazy-loads the universal modal handler
 * Triggers: [data-modal-target], [data-modal-image], and legacy a[href^="#"] -> .modal
 * 
 * Dynamic import ensures the Modal library only loads when a modal is actually triggered
 */
/* global Promise */

let handlerInitialized = false;
let handlerPromise = null;

function detectModalTrigger(target) {
    // Check for explicit modal triggers
    if (target.closest("[data-modal-target]")) return true;
    if (target.closest("[data-modal-image]")) return true;

    // Legacy fallback: anchor with href pointing to a .modal element
    const anchor = target.closest('a[href^="#"]');
    if (anchor) {
        const href = anchor.getAttribute("href");
        if (href && href !== "#") {
            const modalId = href.substring(1);
            const modalElement = document.getElementById(modalId);
            if (modalElement && modalElement.classList.contains("modal")) {
                return true;
            }
        }
    }

    return false;
}

function initModalHandler() {
    if (handlerInitialized) {
        return Promise.resolve();
    }

    if (!handlerPromise) {
        handlerPromise = import(/* webpackChunkName: "modal-handler" */ "/Assets/js/common/modal-handler.js")
            .then((module) => {
                module.initUniversalModalHandler();
                handlerInitialized = true;
            })
            .catch((error) => {
                handlerPromise = null; // Reset so it can be retried
                throw error;
            });
    }

    return handlerPromise;
}

// Delegated click listener that lazy-loads the handler on first modal interaction
document.addEventListener("click", (event) => {
    if (detectModalTrigger(event.target)) {
        // Prevent default immediately to avoid navigation
        const trigger = event.target.closest("a, [data-modal-target], [data-modal-image]");
        if (trigger && trigger.tagName === "A") {
            event.preventDefault();
        }

        // Load the handler, then replay the click
        if (!handlerInitialized) {
            event.stopImmediatePropagation(); // Stop this event from bubbling

            initModalHandler().then(() => {
                // Replay the click event after handler is initialized
                const replayEvent = new MouseEvent("click", {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                    detail: event.detail,
                    screenX: event.screenX,
                    screenY: event.screenY,
                    clientX: event.clientX,
                    clientY: event.clientY,
                    ctrlKey: event.ctrlKey,
                    shiftKey: event.shiftKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    button: event.button
                });
                event.target.dispatchEvent(replayEvent);
            });
        }
    }
}, true); // Use capture phase to intercept before other handlers
